import { Injectable } from '@angular/core';
import { Observable} from 'rxjs/Observable'
import { Subject} from 'rxjs/Subject'

import { OAuthService } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc';
import { AuthConfig } from 'angular-oauth2-oidc';
import { RequestOptions, Headers } from '@angular/http';
import { ClientSideUtility } from './ClientSideUtility';

export interface IDPConfiguration{
    baseURL:string;
    idpURL:string;
    idpRedirect:string;
    idpClient:string;
    idpScope:string;
    idpPostLogoutURL: string;
    idpSilentRefreshURL: string;
    idpDoSilentRefresh: boolean;
}

@Injectable()
export abstract class AuthenticationBase{
    constructor(protected oauthService: OAuthService){}
    redirectURL:string = null;
    isAuthenticationDone:Subject<boolean>;
    abstract configure(configuration: IDPConfiguration):void;
    abstract login():void;
    abstract logout():void;
    abstract getAccesstoken():string;
    abstract isAuthenticated():boolean;
    abstract isAuthenticationCompleted():Observable<boolean>;
    abstract getAuthenticationHeader():RequestOptions;
}

@Injectable()
export class Authentication extends AuthenticationBase {
    
    private authConfig: AuthConfig;
    
    constructor(protected oauthService: OAuthService, private clientSideUtility: ClientSideUtility)
    {
        super(oauthService);
        this.isAuthenticationDone = new Subject<boolean>();
    }

    public configure(configuration: IDPConfiguration):void {
        this.authConfig = new AuthConfig();
        this.authConfig.issuer = configuration.idpURL;
        this.authConfig.redirectUri = configuration.baseURL + configuration.idpRedirect;
        this.authConfig.clientId = configuration.idpClient;
        this.authConfig.scope = configuration.idpScope;
        this.authConfig.postLogoutRedirectUri = configuration.baseURL + configuration.idpPostLogoutURL;
        this.authConfig.responseType = 'id_token token';

        if (configuration.idpDoSilentRefresh == true){
            this.authConfig.silentRefreshRedirectUri = configuration.baseURL + configuration.idpSilentRefreshURL;
            this.authConfig.timeoutFactor = 0.5;
        }

        this.oauthService.configure(this.authConfig);
        this.oauthService.tokenValidationHandler = new JwksValidationHandler();
        this.oauthService.loadDiscoveryDocumentAndTryLogin();        
         
        this.oauthService.events.subscribe(e => {
            console.debug('oauth/oidc event', e);
        });
    
        this.oauthService.events.filter(e => e.type === 'session_terminated').subscribe(e => {
            console.debug('Your session has been terminated!');
        });
        
        this.oauthService.events.filter(e => e.type === 'token_received').subscribe(e => {
            console.debug('Token received!');
            this.isAuthenticationDone.next(true);
        });

        if (configuration.idpDoSilentRefresh == true) {
          this.oauthService.setupAutomaticSilentRefresh();

          this.oauthService.events.filter(e => e.type === 'silently_refreshed').subscribe(e => {
            console.log('Silent Token refreshed!');
          });
        }
      }

      login(): void {
        this.oauthService.initImplicitFlow();
      }

      logout(): void {
        this.isAuthenticationDone.next(false);
        this.oauthService.logOut();
      }

      getAccesstoken():string{
          return this.oauthService.getAccessToken();
      }
      
      isAuthenticated(): boolean {
        return this.oauthService.hasValidAccessToken()
      }

      isAuthenticationCompleted(): Observable<boolean> {                    
        return this.isAuthenticationDone.asObservable();
    }

    getAuthenticationHeader():RequestOptions{

        if(!this.oauthService.hasValidAccessToken()){            
            this.oauthService.silentRefresh().then(i => {
                console.log('Silent Token refreshed!', i);
            })
            .catch(err => console.log('refresh error', err));

            this.clientSideUtility.delay(20);
        }

        let token = 'Bearer ' + this.oauthService.getAccessToken();
        let options = new RequestOptions({ headers:new Headers()});
        options.headers.append("Accept", "application/json");
        options.headers.append("Authorization", token);
        return options;
    }
}



// WEBPACK FOOTER //
// C:/TeamCity/buildAgent/work/4b34a5ca2bd08993/UI/rp/src/app/Shared/service/Authentication.ts